import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 24px;
  padding-inline: 40px;
  gap: 25px;

  label,
  span {
    font-size: 14px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 40px;
`;
